import { render, staticRenderFns } from "./BaseToolbarSyncStatus.vue?vue&type=template&id=be286534"
import script from "./BaseToolbarSyncStatus.vue?vue&type=script&lang=js"
export * from "./BaseToolbarSyncStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports